import { useMock } from './utils';

const connectURL = window.location.origin;

export async function authenticateToConnect({
  email,
  password,
}: {
  email: string;
  password: string;
}) {
  if (!useMock) {
    await fetch(`${connectURL}/api/authentication.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user: email,
        password,
        persistentLogin: false,
      }),
    });
  } else {
    console.log('Authenticate on Connect');
  }
}
